import Model, { attr, belongsTo } from '@ember-data/model';

export default class KycSdkToken extends Model {
  @attr value;

  @belongsTo('stakeholder', { async: false, inverse: 'kycSdkToken' }) stakeholder;
}
